<template>
  <div class="gradeSelectDiv">
    <div class="gradeSelect">
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">基础信息</div>
      </div>
      <div class="userData">
        <div class="name">
          <div class="nameTitle">姓名</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.name"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="sex">
          <div class="nameTitle">性别</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.sex"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="xueji">
          <div class="nameTitle">学级（入学年份）</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.xueji"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="xuejie">
          <div class="nameTitle">学届（毕业年份）</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.xuejie"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="education">
          <div class="nameTitle">学历</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.xueli"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="college">
          <div class="nameTitle">院系</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.college"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="major">
          <div class="nameTitle">专业</div>
          <el-input
            placeholder="请输入内容"
            v-model="inputData.major"
            :disabled="true"
          >
          </el-input>
        </div>
      </div>
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">事情描述</div>
      </div>
      <div class="select">
        <el-select v-model="select" placeholder="请选择">
          <el-option label="补证" value="补证"> </el-option>
          <el-option label="成绩查询" value="成绩查询"> </el-option>
        </el-select>
      </div>
      <div class="textarea">
        <el-input
          type="textarea"
          placeholder="请描述您的需要"
          v-model="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 6, maxRows: 6 }"
        >
        </el-input>
      </div>
      <div class="submit">
        <button class="submitBtn" @click="submit">提 交</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputData: "",
      select: "补证",
      textarea: "",
      type: 1,
    };
  },
  created() {
    this.getGrade();
  },
  methods: {
    async getGrade() {
      const result = await this.$http.get("/applyScoreRecord/getUserInfo", {
        params: { userId: window.localStorage.getItem("user_id") }
      });
      this.inputData = result.data;
      if (this.inputData.sex == 1) {
        this.inputData.sex = "男";
      } else if (this.inputData.sex == 2) {
        this.inputData.sex = "女";
      }
    },
    async submit() {
      if (this.select == "成绩查询") {
        this.type = 0;
      }
      const result = await this.$http({
        url: "/applyScoreRecord/getUserInfo",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          userId: window.localStorage.getItem("user_id"),
          type: this.type,
          applyComment: this.textarea,
        }),
      });
      if (result.data.success == true) {
        this.$toast("提交成功");
        window.history.back(-1);
      } else {
        this.$toast(result.data.msg);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.gradeSelectDiv {
  position: relative;
  .gradeSelect {
    position: relative;
    left: 5%;
    width: 90%;
  }
  .userData {
    margin: 10px 0 20px 0;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 15px;
    .name,
    .sex,
    .xueji,
    .xuejie,
    .education,
    .college,
    .major {
      position: relative;
      left: 3%;
      width: 94%;
      .nameTitle {
        position: relative;
        left: 3%;
        margin-top: 10px;
        font-weight: bold;
        color: #333333;
      }
      .el-input {
        margin: 10px 0;
      }
    }
  }
  .select {
    margin-top: 10px;
    .el-select {
      width: 100%;
    }
  }
  .textarea {
    margin: 15px 0 40px 0;
  }
  .submit {
    width: 100%;
    margin-bottom: 20px;
    .submitBtn {
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}
.title {
  margin-top: 10px;
  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }
  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
/deep/.el-input__inner {
  color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/service/GradeSelect.vue